/**
 * @file portalContainer.tsx
 * @brief Where floating menus portal to while a sheet or dialog is open.
 *
 * @details
 * DES (01-10-2026): "why cant i search in country picker", in Edit
 * company. The picker's menu portalled to `<body>`, outside the sheet; the
 * sheet traps focus inside itself, so the moment the menu's search box took
 * focus the sheet pulled it back to its first tab, and typing went nowhere.
 * A sheet now renders an empty anchor inside its own content and provides
 * it here; `DropdownMenuContent` portals into it, so the menu (and its
 * search box) is inside the focus trap. The menus are fixed-positioned, so
 * where they sit in the DOM does not move them on screen.
 *
 * @author DES
 * @date 01-10-2026
 */

import { createContext, useContext, useState, type ReactNode } from "react";

const PortalContainerContext = createContext<HTMLElement | null>(null);

export function usePortalContainer(): HTMLElement | null {
  return useContext(PortalContainerContext);
}

/** Renders its children plus the anchor element menus portal into. */
export function PortalContainerProvider({ children }: { children: ReactNode }) {
  const [el, setEl] = useState<HTMLDivElement | null>(null);
  return (
    <PortalContainerContext.Provider value={el}>
      {children}
      <div ref={setEl} data-portal-container="" />
    </PortalContainerContext.Provider>
  );
}
